import React from 'react';
import './ContentSection.css';

const ContentSection = () => {
  const features = [
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      ),
      title: '13 Comfortable Rooms',
      description: 'Choose from our well-maintained Standard and Deluxe rooms'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 6v6l4 2"/>
        </svg>
      ),
      title: 'Dining Options',
      description: 'Complimentary breakfast and dine-in facilities available'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"/>
          <path d="M5 17v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4"/>
          <circle cx="9" cy="19" r="2"/>
          <circle cx="15" cy="19" r="2"/>
        </svg>
      ),
      title: 'Cab Services',
      description: 'Local sightseeing and Khatushyam Ji transfers'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
      ),
      title: 'Couple Friendly',
      description: 'We welcome all couples with complete privacy and respect'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7l10 5 10-5-10-5z"/>
          <path d="M2 17l10 5 10-5"/>
          <path d="M2 12l10 5 10-5"/>
        </svg>
      ),
      title: 'Heritage Look',
      description: 'Experience Rajasthani culture in our decor'
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
          <circle cx="12" cy="10" r="3"/>
        </svg>
      ),
      title: 'Prime Location',
      description: 'Easy access to major tourist attractions and city center'
    }
  ];

  return (
    <div className="content-section">
      <div className="content-container">
        <div className="text-content">
          <h2 className="section-heading">About The Jaipur Hotels</h2>
          <p className="section-description">
            Located in the heart of Jaipur at Nehru Nagar, The Jaipur Hotels is your ideal choice for a comfortable and convenient stay in Rajasthan's capital city. Our property combines the charm of traditional Rajasthani heritage with modern comforts, creating a welcoming atmosphere for all our guests.
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-box">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContentSection;
